/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CountryCode } from "./CountryCode";
import {
  CountryCodeFromJSON,
  CountryCodeFromJSONTyped,
  CountryCodeToJSON,
  CountryCodeToJSONTyped,
} from "./CountryCode";

/**
 *
 * @export
 * @interface LookUpPostalCodeResponse
 */
export interface LookUpPostalCodeResponse {
  /**
   *
   * @type {CountryCode}
   * @memberof LookUpPostalCodeResponse
   */
  countryCode: CountryCode;
  /**
   *
   * @type {string}
   * @memberof LookUpPostalCodeResponse
   */
  stateOrProvinceCode: string;
  /**
   *
   * @type {string}
   * @memberof LookUpPostalCodeResponse
   */
  city: string;
  /**
   *
   * @type {number}
   * @memberof LookUpPostalCodeResponse
   */
  longitude: number;
  /**
   *
   * @type {number}
   * @memberof LookUpPostalCodeResponse
   */
  latitude: number;
}

/**
 * Check if a given object implements the LookUpPostalCodeResponse interface.
 */
export function instanceOfLookUpPostalCodeResponse(
  value: object,
): value is LookUpPostalCodeResponse {
  if (!("countryCode" in value) || value["countryCode"] === undefined)
    return false;
  if (
    !("stateOrProvinceCode" in value) ||
    value["stateOrProvinceCode"] === undefined
  )
    return false;
  if (!("city" in value) || value["city"] === undefined) return false;
  if (!("longitude" in value) || value["longitude"] === undefined) return false;
  if (!("latitude" in value) || value["latitude"] === undefined) return false;
  return true;
}

export function LookUpPostalCodeResponseFromJSON(
  json: any,
): LookUpPostalCodeResponse {
  return LookUpPostalCodeResponseFromJSONTyped(json, false);
}

export function LookUpPostalCodeResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LookUpPostalCodeResponse {
  if (json == null) {
    return json;
  }
  return {
    countryCode: CountryCodeFromJSON(json["countryCode"]),
    stateOrProvinceCode: json["stateOrProvinceCode"],
    city: json["city"],
    longitude: json["longitude"],
    latitude: json["latitude"],
  };
}

export function LookUpPostalCodeResponseToJSON(
  json: any,
): LookUpPostalCodeResponse {
  return LookUpPostalCodeResponseToJSONTyped(json, false);
}

export function LookUpPostalCodeResponseToJSONTyped(
  value?: LookUpPostalCodeResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    countryCode: CountryCodeToJSON(value["countryCode"]),
    stateOrProvinceCode: value["stateOrProvinceCode"],
    city: value["city"],
    longitude: value["longitude"],
    latitude: value["latitude"],
  };
}
